import type { PublicationCode } from '@/scopes/common/domain/models'
import type { Usp } from '../../pages/SearchPage/components/Results/Usps'
import { PublicationCodes } from '@/scopes/common/domain/models'

const SEARCH_PAGE_USPS: Record<string, string[]> = {
  SZ: ['/laagste-prijsgarantie', '/flexibel-omruilen', '/vakantiegarantie'],
  KZ: ['/prisgaranti', '/fleksibel-og-gratis-aendring-af-rejse', 'https://service.sunweb.com/da/support/solutions/articles/103000196085'],
  QZ: ['/lagsta-prisgaranti', '/flexibel-ombokning', '/solresor/res-tryggt-med-sunweb'],
  FZ: ['/garantie-prix-le-plus-bas', '/echange-flexible', '/paiement-plusieurs-fois'],
  FS: ['/fr/garantie-prix-le-plus-bas', '/fr/echange-flexible', '/fr/aeroports'],
  BZ: ['/nl/laagste-prijsgarantie', '/nl/flexibel-omruilen', '/nl/vakantiegarantie'],
  WG: ['/wintersport/inclusief-skipas', '/laagste-prijsgarantie', '/wintersport/flexibel-omruilen'],
  BW: ['/nl/skivakantie/inclusief-skipas', '/nl/laagste-prijsgarantie', '/nl/flexibel-omruilen'],
  FH: ['/fr/ski/materiel-ski-offert', '/fr/echange-flexible', '/fr/garantie-prix-le-plus-bas'],
  FW: ['/ski/materiel-ski-offert', '/garantie-prix-le-plus-bas', '/ski/paiement-plusieurs-fois'],
  UW: ['/ski/search', '/ski/search?Country%5B0%5D=13&TransportType=Flight', '/price-guarantee'],
  KW: ['/skiferie/sog', '/skiferie/world-ski-awards', '/prisgaranti'],
  DW: ['/skiurlaub/mit-skipass', '/tiefpreisgarantie', '/skiurlaub/flexibler-skiurlaub'],
  QW: ['/skidresor/sok', '/lagsta-prisgaranti', '/flexibel-ombokning'],
}

function getSearchPageUSPs(publicationCode: PublicationCode): Usp[] | null {
  if (!SEARCH_PAGE_USPS[publicationCode]) {
    return null
  }

  if (PublicationCodes.isSunwebWinterPublicationCode(publicationCode)) {
    return [
      {
        translation: 'search_results_winter_usp1',
        link: SEARCH_PAGE_USPS[publicationCode][0],
      },
      {
        translation: 'search_results_winter_usp2',
        link: SEARCH_PAGE_USPS[publicationCode][1],
      },
      {
        translation: 'search_results_winter_usp3',
        link: SEARCH_PAGE_USPS[publicationCode][2],
      },
    ]
  }

  return [
    {
      translation: 'search_results_usp1',
      link: SEARCH_PAGE_USPS[publicationCode][0],
    },
    {
      translation: 'search_results_usp2',
      link: SEARCH_PAGE_USPS[publicationCode][1],
    },
    {
      translation: 'search_results_usp3',
      link: SEARCH_PAGE_USPS[publicationCode][2],
    },
  ]
}

function getPlpHeroImageUrl(publicationCode: PublicationCode, staticMediaServerBaseUrl: string | null) {
  if (!staticMediaServerBaseUrl) {
    return ''
  }

  if (PublicationCodes.isSunwebWinterPublicationCode(publicationCode)) {
    return `${staticMediaServerBaseUrl}/bg_qs_winter.jpg`
  }

  if (PublicationCodes.isSunwebSummerPublicationCode(publicationCode)) {
    if (publicationCode === 'QZ') {
      return `${staticMediaServerBaseUrl}/bg_qs_sun.jpg`
    }

    return `${staticMediaServerBaseUrl}/bg_qs_sun_new.jpg`
  }

  if (PublicationCodes.isElizaPublicationCode(publicationCode)) {
    return `${staticMediaServerBaseUrl}/bg_qs_eliza.jpg`
  }

  return ''
}

function showAIFilter(publicationCode: PublicationCode, showAIFilterWG: boolean = false): boolean {
  return publicationCode === 'SZ' || (publicationCode === 'WG' && showAIFilterWG)
}

export { getPlpHeroImageUrl, getSearchPageUSPs, showAIFilter }
